<nx-message-banner context="warning" closeButtonLabel="Close error message banner" (close)="errorBanner = false"
    *ngIf="errorBanner" class="nx-margin-bottom-xs errorBanner">
    <span class="nx-font-weight-bold">{{bannerTitle}}</span><br />
    {{bannerText==="Unknown"? bannerMessage :bannerText}}
</nx-message-banner>